export enum OrderProductStatus {
	ToDo = "ToDo",
	Incomplete = "Incomplete",
	AssignedToConfectioner = "AssignedToConfectioner",
	Ready = "Ready",
}
